/* Partner content · aligned to the live ofinancial.markets/partner
   programme structure: Introducer (up to 50% spread rev-share, daily
   payouts) + Ambassador (fixed monthly fee + spread revenue share) +
   Custom bespoke schemes for high-volume partners and master-IBs. */

import { Rocket, Link2, BarChart3, Wallet, Megaphone, Headphones, MessageCircle, Shield } from "lucide-react";

export const PARTNER_STEPS = [
  {
    icon: Rocket,
    title: "1. Apply",
    body: "Send your network details to support@ofinancial.markets or use the application form above. Most applications are approved within one business day.",
  },
  {
    icon: Link2,
    title: "2. Choose your track",
    body: "Introducer for volume-based spread rebates, Ambassador for a guaranteed monthly fee plus spread revenue, or Custom for master-IB and white-label structures.",
  },
  {
    icon: Megaphone,
    title: "3. Get your tracking + creative",
    body: "We provision your unique referral link and dashboard, and email a marketing toolkit (banners, prepared copy, B-roll, brand book) so you can launch in 24h.",
  },
  {
    icon: BarChart3,
    title: "4. Track in real time",
    body: "Your dashboard updates live · clicks, FTDs, active traders, lots traded and projected revenue. No opaque adjustments, no delayed reporting.",
  },
  {
    icon: Wallet,
    title: "5. Get paid every month",
    body: "Daily Introducer payouts via USDT, USDC, wire or Wise. Ambassador retainers paid monthly. $100 minimum payout.",
  },
];

export const PARTNER_FAQ = [
  {
    q: "Which programme should I choose · Introducer or Ambassador?",
    a: "Introducer suits anyone with a steady referral pipeline (signal services, IBs, sub-network operators) · earnings are pure spread-revenue rebates and scale linearly with referred trading volume. Ambassador adds a guaranteed monthly base fee on top of spread revenue, so it suits content creators, educators and regional reps who want a predictable floor while their audience grows.",
  },
  {
    q: "What's the real commission rate?",
    a: "Up to 50% of the spread revenue generated by every active trader you refer · paid daily on the Introducer track, for as long as they keep trading. The exact percentage scales with your network size; large IBs and master structures negotiate custom rates under the Custom Schemes track.",
  },
  {
    q: "Is there a guaranteed monthly fee?",
    a: "Only on Ambassador. The base fee is set during onboarding based on your reach and content cadence, and is paid in addition to spread rebates. Introducer is pure performance-based.",
  },
  {
    q: "How is a referral attributed to me?",
    a: "Either (a) the visitor signs up via your unique tracking link, or (b) they enter your dedicated promo code on the signup form. First-touch wins · your link beats a competitor's code for the same visitor.",
  },
  {
    q: "When do I get paid?",
    a: "Introducer payouts are daily — paid every business day in USDT, USDC, wire or Wise (settlement of the prior trading day's rebates). Ambassador retainers are paid monthly on the first Tuesday of the following month. $100 minimum on either track · balances below that roll over automatically.",
  },
  {
    q: "What payout methods do you support?",
    a: "USDT (TRC-20 / ERC-20), USDC, USD bank wire, and Wise. Crypto settles within 1 business day; wires take 2–3 business days depending on your bank.",
  },
  {
    q: "Can I run paid traffic to my referral link?",
    a: "Yes, except for branded keywords (\"OFinancial\", \"OFinancial Markets\", \"ofinancial.markets\" and common typos). Search ads on generic broker / MT5 / FX-trading keywords are fine. Display, native and social ads are unrestricted on any non-prohibited keyword.",
  },
  {
    q: "Cookie / attribution window?",
    a: "30 days from first click. If the visitor clicks your link multiple times before signing up, the timer resets on every new click.",
  },
  {
    q: "What about refunds and chargebacks?",
    a: "If a referred client withdraws their deposit inside the 14-day cooling-off period, the corresponding spread rebate is reversed against your next cycle. Only NET commission is paid out.",
  },
  {
    q: "Do I get a dedicated point of contact?",
    a: "Yes · every approved partner is assigned a partnership manager from day one. They handle onboarding, payout questions, dispute escalation and any custom-deal conversations. Most replies inside one business day.",
  },
  {
    q: "What happens if my network goes inactive?",
    a: "Partner accounts with no clicks or FTDs for 90 consecutive days are paused (not closed). Email support@ofinancial.markets at any time to reactivate · your historical tracking and rev-share trail stay intact.",
  },
  {
    q: "Who do I contact for partnership questions?",
    a: "support@ofinancial.markets · our partnership team handles every enquiry and most are answered within one business day.",
  },
];

export const PARTNER_PRIVATE = {
  support: [
    { name: "Dedicated partnership manager",   note: "Human · single point of contact", icon: Headphones },
    { name: "Live referrals dashboard",        note: "Clicks · FTDs · lots · revenue", icon: BarChart3 },
    { name: "Unique referral link & promo code", note: "30-day attribution window",     icon: Link2 },
    { name: "Direct line to support",          note: "support@ofinancial.markets · < 24h reply", icon: MessageCircle },
    { name: "Custom-deal negotiation",         note: "For master IBs and large networks", icon: Shield },
  ],
  payoutSchedule: [
    { row: "Introducer rev-share", value: "Up to 50%" },
    { row: "Ambassador base fee",  value: "Negotiable · monthly" },
    { row: "Minimum payout",       value: "$100" },
    { row: "Payout cycle",         value: "Introducer daily · Ambassador monthly" },
    { row: "Hold period",          value: "14 days from FTD" },
    { row: "Payout methods",       value: "USDT · USDC · Wire · Wise" },
  ],
  dispute: "Open a dispute by replying to your most recent payout email or writing to support@ofinancial.markets within 30 days of the cycle in question. Disputes are acknowledged within 1 business day and resolved within 10. Our internal payout records are the source of truth.",
};
